export const securityCheck = {
  check,
};

function check(location: string, roles: string[]) {
  if (!roles.includes("Partner") && location == "/partnerlounge") return false;
  if (!roles.includes("Toolbox") && location == "/mytoolbox") return false;
  if (!roles.includes("Catalog") && location == "/quickfinder") return false;
  if (!roles.includes("Admin") && location.includes("/admin/")) return false;
  if (!roles.includes("Vertrieb") && location.includes("/sales/")) return false;
  if (!roles.includes("Vertriebsadmin") && location.includes("/salesadmin/"))
    return false;
  else return true;
}
